var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/gift",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625,7.265625 L17.165625,7.265625 C17.484375,6.7640625 17.671875,6.16875 17.671875,5.53125 C17.671875,3.74765625 16.2210938,2.296875 14.4375,2.296875 C13.4671875,2.296875 12.5929687,2.728125 12,3.4078125 C11.4070312,2.728125 10.5328125,2.296875 9.5625,2.296875 C7.77890625,2.296875 6.328125,3.74765625 6.328125,5.53125 C6.328125,6.16875 6.51328125,6.7640625 6.834375,7.265625 L3.375,7.265625 C2.96015625,7.265625 2.625,7.60078125 2.625,8.015625 L2.625,12.703125 C2.625,12.80625 2.709375,12.890625 2.8125,12.890625 L3.75,12.890625 L3.75,20.953125 C3.75,21.3679688 4.08515625,21.703125 4.5,21.703125 L19.5,21.703125 C19.9148438,21.703125 20.25,21.3679688 20.25,20.953125 L20.25,12.890625 L21.1875,12.890625 C21.290625,12.890625 21.375,12.80625 21.375,12.703125 L21.375,8.015625 C21.375,7.60078125 21.0398437,7.265625 20.625,7.265625 Z M12.796875,5.53125 C12.796875,4.6265625 13.5328125,3.890625 14.4375,3.890625 C15.3421875,3.890625 16.078125,4.6265625 16.078125,5.53125 C16.078125,6.4359375 15.3421875,7.171875 14.4375,7.171875 L12.796875,7.171875 L12.796875,5.53125 Z M9.5625,3.890625 C10.4671875,3.890625 11.203125,4.6265625 11.203125,5.53125 L11.203125,7.171875 L9.5625,7.171875 C8.6578125,7.171875 7.921875,6.4359375 7.921875,5.53125 C7.921875,4.6265625 8.6578125,3.890625 9.5625,3.890625 Z M4.21875,11.296875 L4.21875,8.859375 L11.203125,8.859375 L11.203125,11.296875 L4.21875,11.296875 Z M5.34375,12.890625 L11.203125,12.890625 L11.203125,20.109375 L5.34375,20.109375 L5.34375,12.890625 Z M18.65625,20.109375 L12.796875,20.109375 L12.796875,12.890625 L18.65625,12.890625 L18.65625,20.109375 Z M19.78125,11.296875 L12.796875,11.296875 L12.796875,8.859375 L19.78125,8.859375 L19.78125,11.296875 Z",
    id: "Shape",
    fill: "#205527"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.dc3203ba62ef58f5dca721d78f05abef.svg";
export { ForwardRef as ReactComponent };